import PropTypes from 'prop-types';
import React from 'react';
import NavButton from './navbar/container/navbutton.jsx';

import proxyFactory from './proxy_factory.jsx';
import Headroom from 'react-headroom';
import classnames from 'classnames';

function Navbar(props) {
    const { showHome = true, pin = true } = props;
    let { children } = props;

    let titleMarkup;
    if (props.title) {
        titleMarkup = (
            <h1 aria-hidden="true" className="contextual-title">
                {props.title}
            </h1>
        );
    }
    let home;
    if (showHome) {
        home = <NavButton />;
    }

    const tmp = classnames({
        headroom: pin,
        'headroom--pinned': pin,
    });

    return (
        <Headroom disableInlineStyles>
            <div className={tmp}>
                <nav className="navbar" aria-label="Main">
                    <div className="navbar-inner">
                        <div className="container">
                            {home}
                            {titleMarkup}
                            {children}
                        </div>
                    </div>
                </nav>
            </div>
        </Headroom>
    );
}
Navbar.propTypes = {
    contentId: PropTypes.number,
    children: PropTypes.any,
    navThickBorder: PropTypes.bool,
    params: PropTypes.object,
    title: PropTypes.string,
    showHome: PropTypes.bool,
    pin: PropTypes.bool,
};

export default proxyFactory(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar.jsx